import Vue from 'vue';

import types from './types';

export default {
  [types.mutations.RECEIVE_WEEK] (store, payload) {
    console.log('Mutation: RECEIVE_WEEK', payload);
    const weekId = payload.weekId;
    Vue.set(store.weeks, weekId, {bookings: payload.bookings});
    store.fetch.status = 'done'
  },
  [types.mutations.FETCHING_WEEK] (store) {
    store.fetch.status = 'pending'
  },
  [types.mutations.CREATING_BOOKING] (store) {
    console.log('MUTATION BOOKING CREATING')
    store.create.status = 'pending'
  },
  [types.mutations.BOOKING_CREATED] (store) {
    console.log('MUTATION BOOKING CREATED')
    store.create.status = 'done'
  },
  [types.mutations.BOOKING_CREATE_FAILED] (store) {
    console.log('MUTATION BOOKING CREATE FAILED')
    store.create.status = 'failed'
  },
  [types.mutations.EDITING_BOOKING] (store) {
    console.log('MUTATION EDITING BOOKING')
    store.edit.status = 'pending'
  },
  [types.mutations.BOOKING_EDITED] (store) {
    console.log('MUTATION BOOKING EDITED')
    store.edit.status = 'done'
  },
  [types.mutations.BOOKING_EDIT_FAILED] (store) {
    console.log('MUTATION BOOKING EDIT FAILED')
    store.edit.status = 'failed'
  },
  [types.mutations.DELETING_BOOKING] (store) {
    console.log('MUTATION DELETING BOOKING')
    store.delete.status = 'pending'
  },
  [types.mutations.BOOKING_DELETED] (store) {
    console.log('MUTATION BOOKING DELETED')
    store.delete.status = 'done'
  },
  [types.mutations.BOOKING_DELETE_FAILED] (store) {
    console.log('MUTATION BOOKING DELETE FAILED')
    store.delete.status = 'failed'
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/booking/mutations.js